import {html, css} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent'
import DetailRow from '../../components/StaticDetailList/DetailRow'
import LinkCell from "@isceco/widget-library2/basic-elements/List/cell/LinkCell";
import VerordnungMonitoringService from "../VerordnungMonitoring/VerordnungMonitoringService";
import KontingentService from "../../services/KontingentService";
import MonitoringKontingentDto from "./MonitoringKontingentDto";
import EnergyCell from "../../components/StaticDetailList/EnergyCell";
import EmailCell from "../../components/StaticDetailList/EmailCell";
import KontingentperiodeService from "../../services/KontingentperiodeService";

import '@isceco/widget-library2/basic-elements/Title/Title'
import '@isceco/widget-library2/basic-elements/Button/Button'
import '../../components/StaticDetailList/StaticDetailList'

export default class KontingentMonitoringUebersicht extends WebComponent {
  static get properties() {
    return {
      kontingent: {type: MonitoringKontingentDto}
    }
  }

  constructor() {
    super()
    this.kontingentService = new KontingentService()
    this.kontingentperiodeService = new KontingentperiodeService()
    this.verordnungService = new VerordnungMonitoringService()
  }

  get translationFile() {
    return './views/KontingentMonitoring/i18n.json'
  }

  get css() {
    return css`
      .twin-static-list-container {
        display: flex;
        gap: 20px;
        width: 100%;
      }

      .twin-static-list-item {
        width: 50%;
      }
    `
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  getTemplate() {
    return html`
      <div class="twin-static-list-container">
        <div class="twin-static-list-item">
          ${this.getKontingentTemplate()}
        </div>
        <div class="twin-static-list-item">
          ${this.getVerfuegungTemplate()}
        </div>
      </div>
    `
  }

  getKontingentTemplate() {
    return this.kontingent ? html`
        <isceco-title size="medium" text="${this.i18n.translate('kontingentMonitoring.uebersicht.kontingent.title')}">
        </isceco-title>
        <eko-static-detail-list id="kontingentList" .data="${this.getKontingentListData()}"></eko-static-detail-list>
    ` : html``
  }

  getVerfuegungTemplate() {
    return this.kontingent?.art === 'KONT' ? html`
      <isceco-title size="medium" text="${this.i18n.translate('kontingentMonitoring.uebersicht.verfuegung.title')}">
        <isceco-button @click="${this._downloadVerfuegung}" icon="file pdf outline" variant="tertiary"
                       text="${this.i18n.translate('kontingentMonitoring.uebersicht.verfuegung.download.button')}"
        ></isceco-button>
      </isceco-title>
      <eko-static-detail-list id="verfuegungList" .data="${this.getVerfuegungListData()}"></eko-static-detail-list>
    ` : html``
  }

  getKontingentListData() {
    if (!this.kontingent) {
      return []
    }
    return [
      new DetailRow(this.i18n.translate('kontingentMonitoring.uebersicht.kontingent.berechnet'), this.kontingent.berechneterWert, new EnergyCell()),
      new DetailRow(this.i18n.translate('kontingentMonitoring.uebersicht.kontingent.verfuegt'), this.kontingent.angepassterWert ?? this.kontingent.berechneterWert, new EnergyCell()),
      new DetailRow(this.i18n.translate('kontingentMonitoring.uebersicht.kontingent.mitWeitergaben'), 'FAENERGY-38',
        new LinkCell({target: '_blank', url: _ => 'https://services.isceco.admin.ch/jira-pr/browse/FAENERGY-38'})),
      new DetailRow(this.i18n.translate('kontingentMonitoring.uebersicht.kontingent.verbrauch'), this.kontingent.verbrauch, new EnergyCell()),
      new DetailRow(this.i18n.translate('kontingentMonitoring.uebersicht.kontingent.anteil'), isNaN(this.kontingent.anteil) ? undefined : this.kontingent.anteil + '%'),
    ].filter(row => row.dto.value !== undefined)
  }

  getVerfuegungListData() {
    if (!this.kontingent) {
      return []
    }

    return [
      new DetailRow(this.i18n.translate('kontingentMonitoring.uebersicht.verfuegung.versandart'), this.i18n.translate(this.kontingent.versandart)),
      new DetailRow(this.i18n.translate('kontingentMonitoring.uebersicht.verfuegung.versanddatum.elektronisch'),
        this.kontingent.versendetElektronischOn ? formatDateTime(this.kontingent.versendetElektronischOn) : undefined),
      new DetailRow(this.i18n.translate('kontingentMonitoring.uebersicht.verfuegung.versanddatum.postalisch'),
        this.kontingent.versendetPostalischOn ? formatDate(this.kontingent.versendetPostalischOn) : undefined),
      new DetailRow(this.i18n.translate('kontingentMonitoring.uebersicht.verfuegung.versand.reminder1'), 'FAENERGY-706',
        new LinkCell({target: '_blank', url: _ => 'https://services.isceco.admin.ch/jira-pr/browse/FAENERGY-706'})),
      new DetailRow(this.i18n.translate('kontingentMonitoring.uebersicht.verfuegung.versand.reminder2'), 'FAENERGY-706',
        new LinkCell({target: '_blank', url: _ => 'https://services.isceco.admin.ch/jira-pr/browse/FAENERGY-706'})),
      new DetailRow(this.i18n.translate('kontingentMonitoring.uebersicht.verfuegung.download.am'),
        this.kontingent.gpDownloadOn ? formatDateTime(this.kontingent.gpDownloadOn) : undefined),
      new DetailRow(this.i18n.translate('kontingentMonitoring.uebersicht.verfuegung.download.von'), this.kontingent.gpDownloadBy, new EmailCell()),
    ].filter(row => row.dto.value !== undefined)
  }

  _downloadVerfuegung = _ => {
    const filename = `${this.kontingent.srNummer} - ${formatDate(this.kontingent.periodeStart)}`
    this.kontingentService.read(this.kontingent.kontingentId, 'pdf')
      .then(response => response.blob())
      .then(blob => download(toValidFilename(filename, 'pdf'), blob))
      .then(() => this.reload())
  }
}

customElements.define('eko-frontend-kontingent-monitoring-uebersicht', KontingentMonitoringUebersicht)
